import Button, { type ButtonProps } from 'components/button'
import { CheckRounded, CopyIcon } from 'components/icons'
import { useShowSnack } from 'components/snackbar'
import { useState } from 'react'

/** A copy-to-clipboard button with a transient "Copied ✓" state + snackbar. */
export default function CopyButton({
    text,
    label = 'Copy',
    copiedLabel = 'Copied',
    ...props
}: { text: string; label?: string; copiedLabel?: string } & Omit<ButtonProps, 'children' | 'onPress' | 'icon'>) {
    const [copied, setCopied] = useState(false)
    const showSnack = useShowSnack()

    return (
        <Button
            icon={copied ? <CheckRounded size={16} /> : <CopyIcon size={16} />}
            onPress={async () => {
                try {
                    if (!navigator.clipboard?.writeText) throw new Error('Clipboard API unavailable')
                    await navigator.clipboard.writeText(text)
                    setCopied(true)
                    showSnack('Copied to clipboard', 'success')
                    setTimeout(() => setCopied(false), 1800)
                } catch {
                    showSnack('Could not copy', 'danger')
                }
            }}
            {...props}
        >
            {copied ? copiedLabel : label}
        </Button>
    )
}
